import {
  CreateViewCustomColumnTemplateMutation,
  CreateViewCustomColumnTemplateMutationVariables,
  DeleteViewCustomColumnTemplateMutation,
  DeleteViewCustomColumnTemplateMutationVariables,
  GetCandidateCustomColumnsInput,
  GetCandidateCustomColumnsQuery,
  GetCandidateCustomColumnsQueryVariables,
  GetCustomColumnTemplatesForViewQuery,
  GetCustomColumnTemplatesForViewQueryVariables,
  GetViewCustomColumnTemplatesInput,
  UpdateViewCustomColumnTemplateMutation,
  UpdateViewCustomColumnTemplateMutationVariables,
} from 'types/graphql'

import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const Create = gql`
  mutation CreateViewCustomColumnTemplateMutation($input: CreateViewCustomColumnTemplateInput!) {
    createViewCustomColumnTemplate(input: $input) {
      ...ViewColumnTemplateFragment
    }
  }
`
export const useCreateViewCustomColumnTemplateMutation = () => {
  return useMutation<
    CreateViewCustomColumnTemplateMutation,
    CreateViewCustomColumnTemplateMutationVariables
  >({
    mutationDocument: Create,
  })
}

const Delete = gql`
  mutation DeleteViewCustomColumnTemplateMutation($generatedId: String!) {
    deleteViewCustomColumnTemplate(generatedId: $generatedId)
  }
`
export const useDeleteViewCustomColumnTemplateMutation = () => {
  return useMutation<
    DeleteViewCustomColumnTemplateMutation,
    DeleteViewCustomColumnTemplateMutationVariables
  >({
    mutationDocument: Delete,
  })
}

const Get = gql`
  query GetCustomColumnTemplatesForViewQuery($input: GetViewCustomColumnTemplatesInput!) {
    getViewCustomColumnTemplates(input: $input) {
      ...ViewColumnTemplateFragment
    }
  }
`
export const useGetCustomColumnTemplatesForViewQuery = (
  args: Partial<GetViewCustomColumnTemplatesInput>
) => {
  const hasScope = !!args.recordTypeId || !!args.organizationId
  const input: GetViewCustomColumnTemplatesInput = args.recordTypeId
    ? { recordTypeId: args.recordTypeId }
    : { organizationId: args.organizationId ?? -1 }
  return useQuery<
    GetCustomColumnTemplatesForViewQuery,
    GetCustomColumnTemplatesForViewQueryVariables
  >({
    queryKey: [QueryKey.ViewCustomColumnTemplates, args],
    queryDocument: Get,
    variables: {
      input,
    },
    enabled: hasScope,
    gcTime: 0,
    staleTime: 0,
  })
}

const Update = gql`
  mutation UpdateViewCustomColumnTemplateMutation($input: UpdateViewCustomColumnTemplateInput!) {
    updateViewCustomColumnTemplate(input: $input) {
      ...ViewColumnTemplateFragment
    }
  }
`
export const useUpdateViewCustomColumnTemplateMutation = () => {
  return useMutation<
    UpdateViewCustomColumnTemplateMutation,
    UpdateViewCustomColumnTemplateMutationVariables
  >({
    mutationDocument: Update,
  })
}

const GetCandidates = gql`
  query GetCandidateCustomColumnsQuery($input: GetCandidateCustomColumnsInput!) {
    getCandidateCustomColumns(input: $input) {
      candidates {
        ...CandidateCustomColumnFragment
      }
      candidateDiscoverableColumnTypeInfo {
        columnType
        sectionLabel
      }
    }
  }
`
export const useGetCandidateCustomColumnsQuery = (
  args: Partial<GetCandidateCustomColumnsInput>
) => {
  const hasScope = (!!args.recordTypeId || !!args.organizationId) && !!args.viewType
  const input: GetCandidateCustomColumnsInput = {
    viewType: args.viewType!,
    viewDashboardId: args.viewDashboardId,
    ...(args.recordTypeId
      ? { recordTypeId: args.recordTypeId }
      : { organizationId: args.organizationId ?? -1 }),
  }
  return useQuery<GetCandidateCustomColumnsQuery, GetCandidateCustomColumnsQueryVariables>({
    queryKey: [QueryKey.CandidateCustomColumns, args],
    queryDocument: GetCandidates,
    variables: {
      input,
    },
    enabled: hasScope,
    gcTime: 0,
    staleTime: 0,
  })
}
